import { useState } from "react";

/** a simple checkbox with a label */
export function CheckBox(props: {
  readonly checked: boolean,
  readonly onChange: (checked: boolean) => void,
  readonly children: string | JSX.Element,
}) {
  const [id] = useState(Math.random().toString());

  return (<>
    <input type="checkbox" id={id} checked={props.checked} onChange={() => props.onChange(!props.checked)} />
    <label htmlFor={id}>{props.children}</label>
  </>);
}
